import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  NotificationContainer,
  NotificationManager,
} from 'react-notifications';
import ReCAPTCHA from 'react-google-recaptcha';
import { requestPost, requestGet } from '../../api/request';
import { ADD_CONTACTS, GET_SITEKEY } from '../../api/url';
import * as actions from '../../redux/actions';
import { BreadcrumbComponent } from '../Partials/Breadcrumb';

const Contacts = () => {
  const dispatch = useDispatch();
  const dictionary = useSelector((state) => state.dictionaryReducer.dictionary);
  const currentLanguage = useSelector(
    (state) => state.languageReducer.current_language,
  );
  const fontSize = useSelector((state) => state.fontSizeReducer.font_size);

  const [loader, setLoader] = useState(false);
  const [availableSize, setAvailableSize] = useState(10485760);

  const [files, setFiles] = useState([]);
  const [message, setMessage] = useState('');
  const [fio, setFio] = useState('');
  const [job, setJob] = useState('');
  const [country, setCountry] = useState('');
  const [city, setCity] = useState('');
  const [street, setStreet] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [theme, setTheme] = useState('');
  const [token, setToken] = useState('');
  const [siteKey, setSiteKey] = useState(undefined);

  useEffect(() => {
    if (dictionary) {
      dispatch(actions.adjustFontSize(fontSize));
    }
  });

  const addFiles = () => {
    const _files = [...files];

    _files.push({
      file_format: null,
      file_name: null,
      file_size: null,
      base64: null,
    });
    setFiles(_files);
  };

  const errorNotify = (message) => {
    if (typeof message === 'object') {
      for (const key in message) {
        if (Object.prototype.hasOwnProperty.call(message, key)) {
          NotificationManager.error(message[key]);
        }
      }
      return;
    }

    NotificationManager.error(message);
  };

  const removeFile = (index) => {
    const _files = [...files];
    _files.splice(index, 1);
    setFiles(_files);
  };

  const updateAvailableSize = () => {
    const _files = [...files];

    let sum = 10485760;

    if (_files.length > 0) {
      for (let i = 0; i < _files.length; i += 1) {
        if (_files[i].file_size != null) {
          sum = parseFloat(sum) - parseFloat(_files[i].file_size);
        }
      }
    }
    if (sum < 0) {
      errorNotify(dictionary.notifications.text_11);
      setAvailableSize(sum);
      return false;
    }

    setAvailableSize(sum);

    return true;
  };

  useEffect(() => {
    updateAvailableSize();
  }, [files]);

  const onChangeFileInput = (e) => {
    const key = e.target.getAttribute('data-key');
    const value = e.target.files[0];
    const _files = [...files];

    const test = /\.(gif|jpg|jpeg|tiff|png|pdf|txt|xls|xlsx|ppt|pptx|doc|docx|csv)$/i.test(
      value.name,
    );
    if (!test) {
      _files.splice(key, 1);
      setFiles(_files);
      errorNotify(
        `${dictionary.notifications.text_12} gif, jpg, jpeg, tiff, png, pdf, txt, xls, xlsx, ppt, pptx, doc, docx, csv`,
      );

      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(value);

    reader.onloadend = function () {
      const base64String = reader.result
        .replace('data:', '')
        .replace(/^.+,/, '');

      _files[key].file_format = value.name.split('.').pop();
      _files[key].file_name = value.name;
      _files[key].file_size = value.size;
      _files[key].base64 = base64String;
      setFiles(_files);
    };
  };

  const onChangeCaptcha = (value) => {
    setToken(value);
  };

  const onChangeData = (e) => {
    const key = e.target.getAttribute('data-key');

    switch (key) {
      case 'message':
        setMessage(e.target.value);
        break;
      case 'fio':
        setFio(e.target.value);
        break;
      case 'job':
        setJob(e.target.value);
        break;
      case 'country':
        setCountry(e.target.value);
        break;
      case 'city':
        setCity(e.target.value);
        break;
      case 'street':
        setStreet(e.target.value);
        break;
      case 'phone':
        setPhone(e.target.value);
        break;
      case 'email':
        setEmail(e.target.value);
        break;
      case 'theme':
        setTheme(e.target.value);
        break;
      default:
        console.log('no case');
    }
  };

  const validateData = () => {
    const validateInputs = document.querySelectorAll('[data-key]');

    for (let i = 0; i < validateInputs.length; i += 1) {
      const elem = validateInputs[i];
      if (!elem.value) {
        elem.style.border = '1px solid red';
      } else {
        elem.style.border = '';
      }
    }

    if (fio === '' || typeof fio === 'undefined' || fio === null) {
      errorNotify(dictionary.notifications.text_2);
      return false;
    }

    if (job === '' || typeof job === 'undefined' || job === null) {
      errorNotify(dictionary.notifications.text_3);
      return false;
    }
    if (country === '' || typeof country === 'undefined' || country === null) {
      errorNotify(dictionary.notifications.text_4);
      return false;
    }

    if (city === '' || typeof city === 'undefined' || city === null) {
      errorNotify(dictionary.notifications.text_5);
      return false;
    }

    if (street === '' || typeof street === 'undefined' || street === null) {
      errorNotify(dictionary.notifications.text_6);
      return false;
    }

    if (phone === '' || typeof phone === 'undefined' || phone === null) {
      errorNotify(dictionary.notifications.text_7);
      return false;
    }

    if (email === '' || typeof email === 'undefined' || email === null) {
      errorNotify(dictionary.notifications.text_8);
      return false;
    }

    if (theme === '' || typeof theme === 'undefined' || theme === null) {
      errorNotify(dictionary.notifications.text_9);
      return false;
    }

    if (message === '' || typeof message === 'undefined' || message === null) {
      errorNotify(dictionary.notifications.text_1);
      return false;
    }

    if (token === '' || typeof token === 'undefined' || token === null) {
      errorNotify(dictionary.notifications.text_10);
      return false;
    }

    const _files = [...files];

    let sum = 10485760;

    if (_files.length > 0) {
      for (let i = 0; i < _files.length; i += 1) {
        if (_files[i].file_size != null) {
          sum = parseFloat(sum) - parseFloat(_files[i].file_size);
        }
      }
    }
    if (sum < 0) {
      errorNotify(dictionary.notifications.text_11);
      return false;
    }

    return true;
  };

  const getSiteKey = async () => {
    const response = await requestGet(GET_SITEKEY);
    if (response.success) {
      setSiteKey(response.data);
    }
  };

  useEffect(() => {
    if (typeof siteKey === 'undefined') {
      getSiteKey();
    }
  }, [siteKey]);

  const saveContact = async () => {
    setLoader(true);

    if (!validateData()) {
      setLoader(false);
      return;
    }

    const data = {
      token,
      theme,
      email,
      phone,
      street,
      country,
      city,
      job,
      fio,
      message,
      files,
    };

    const response = await requestPost(ADD_CONTACTS, data, {
      'lang_id': currentLanguage.id,
    }, { crossDomain: true });
    if (response.success) {
      setMessage('');
      setFio('');
      setJob('');
      setCountry('');
      setCity('');
      setStreet('');
      setPhone('');
      setEmail('');
      setTheme('');

      setAvailableSize(10485760);
      setFiles([]);

      NotificationManager.success(
        response.message,
        dictionary.notifications.text_13,
      );
    }
    setLoader(false);
  };

  return (
    <>
      {loader === true ? (
        <div className="row d-flex justify-content-md-center align-items-center mt-3 mb-3">
          <div className="spinner-border text-success" role="status">
            <span className="sr-only" />
          </div>
        </div>
      ) : (
        <section className="section awards-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-9">
                <div className="breadcrumbs mt-4">
                  <div className="breadcrumbs-container">
                    <BreadcrumbComponent />
                  </div>
                </div>
                <div className="awards">
                  <div className="awards-title">
                    {dictionary.contact_page.text_1}
                  </div>
                  <div className="awards-subtitle">
                    {dictionary.contact_page.text_2}
                  </div>
                </div>

                <form action="" className="awards-form was-validated">
                  <div className="row">
                    <div className="col-12">
                      <div className="awards-form__input">
                        <input
                          className="input "
                          type="text"
                          value={fio}
                          data-key="fio"
                          onChange={onChangeData}
                          placeholder={dictionary.contact_page.text_3}
                          aria-label=""
                          aria-describedby="basic-addon1"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="awards-form__input">
                        <input
                          className="input"
                          type="text"
                          value={job}
                          data-key="job"
                          onChange={onChangeData}
                          placeholder={dictionary.contact_page.text_4}
                          aria-label=""
                          aria-describedby="basic-addon1"
                          required
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="awards-form__input">
                        <input
                          className="input"
                          type="text"
                          value={country}
                          data-key="country"
                          onChange={onChangeData}
                          placeholder={dictionary.contact_page.text_5}
                          aria-label=""
                          aria-describedby="basic-addon1"
                          required
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="awards-form__input">
                        <input
                          className="input"
                          type="text"
                          value={city}
                          data-key="city"
                          onChange={onChangeData}
                          placeholder={dictionary.contact_page.text_6}
                          aria-label=""
                          aria-describedby="basic-addon1"
                          required
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="awards-form__input">
                        <input
                          className="input"
                          type="text"
                          value={street}
                          data-key="street"
                          onChange={onChangeData}
                          placeholder={dictionary.contact_page.text_7}
                          aria-label=""
                          aria-describedby="basic-addon1"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="awards-form__input">
                        <input
                          className="input"
                          type="text"
                          value={phone}
                          data-key="phone"
                          onChange={onChangeData}
                          placeholder={dictionary.contact_page.text_8}
                          aria-label=""
                          aria-describedby="basic-addon1"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="awards-form__input">
                        <input
                          className="input"
                          type="text"
                          value={email}
                          data-key="email"
                          onChange={onChangeData}
                          placeholder={dictionary.contact_page.text_9}
                          aria-label=""
                          aria-describedby="basic-addon1"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="awards-form__input">
                        <input
                          className="input"
                          type="text"
                          value={theme}
                          data-key="theme"
                          onChange={onChangeData}
                          placeholder={dictionary.contact_page.text_10}
                          aria-label=""
                          aria-describedby="basic-addon1"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="awards-form__textarea">
                        <textarea
                          name=""
                          id=""
                          cols="30"
                          rows="10"
                          data-key="message"
                          value={message}
                          onChange={onChangeData}
                          placeholder={dictionary.contact_page.text_11}
                          aria-label=""
                          aria-describedby="basic-addon1"
                          required
                        />
                      </div>
                    </div>

                    <div className="awards-subtitle">
                      <div className="row mt-4 mb-4 d-flex">
                        {availableSize > 0 ? (
                          <label
                            htmlFor="file"
                            className="text text-success fs-6 text-muted"
                          >
                            {dictionary.contact_page.text_14}
                            {' '}
                            {parseFloat(availableSize / 1024 / 1024).toFixed(2)}
                            {' '}
                            MB
                          </label>
                        ) : (
                          <label
                            htmlFor="file"
                            className="text text-danger fs-6"
                          >
                            {dictionary.contact_page.text_15}
                            {' '}
                            {parseFloat(availableSize / 1024 / 1024).toFixed(2)}
                            {' '}
                            MB
                          </label>
                        )}
                      </div>

                      <div className="col-md-6">
                        {files.length > 0
                          ? files.map((value, index) => (
                            <div key={index} className="input-group mb-3">
                              <input
                                data-key={index}
                                type="file"
                                onChange={onChangeFileInput}
                                className="form-control"
                                name="file"
                                id="file"
                                placeholder=""
                                aria-label="Username"
                                aria-describedby="basic-addon1"
                              />
                              <button
                                type="button"
                                className="btn btn-outline-danger"
                                onClick={() => removeFile(index)}
                              >
                                <i className="bi bi-trash" />
                              </button>
                            </div>
                          ))
                          : null}

                        <div className="col-sm-6 col-md-5">
                          <div className="awards-form__button last">
                            <button
                              type="button"
                              className="button"
                              onClick={() => addFiles()}
                            >
                              {dictionary.contact_page.text_16}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    {typeof siteKey !== 'undefined' ? (
                      <div className="col-12 mt-4 mb-4">
                        <ReCAPTCHA
                          sitekey={siteKey}
                          onChange={onChangeCaptcha}
                        />
                      </div>
                    ) : null}
                    <div className="col-sm-6 col-md-3">
                      <div className="awards-form__button last">
                        <button
                          className="button"
                          type="button"
                          onClick={() => saveContact()}
                        >
                          {dictionary.contact_page.text_12}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      )}
      <NotificationContainer />
    </>
  );
};

export default Contacts;
